import { Action, getModule, Module, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import {
    ILoyaltyBonus,
    ILoyaltyBonusListItem,
    LoyaltyBonusResponseType
} from '@/entity/loyalty/loyaltyBonus/loyaltyBonus/LoyaltyBonus.types';
import { PaginationRequestType } from '@/entity/common/pagination.types';
import { LoyaltyBonusGeneralRequestType } from '@/form/loyalty/loyaltyBonus/LoyaltyBonusGeneral.types';
import { ResponseDataType } from '@/form/form.types';
import { createLogger } from 'vuex';
import { prepareFormData } from '@/store/utils/formDataHelper';

@Module({
    namespaced: true,
    name: 'loyaltyBonus',
    store,
    dynamic: true
})
class LoyaltyBonusModule extends VuexModule {
    loyaltyBonuss: ILoyaltyBonus | null = null;
    loyaltyBonus: ILoyaltyBonusListItem | null = null;
    loyaltyBonusLoaded = false;
    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ loyaltyBonuss: ILoyaltyBonus; loyaltyBonusLoaded: boolean }> {

        let loyaltyBonusLoaded = false;
        const loyaltyBonuss = await store.$repository.loyaltyBonus.fetchAll(prepareFormData(data));

        if (loyaltyBonuss) {
            loyaltyBonusLoaded = true;
        }
        return { loyaltyBonuss, loyaltyBonusLoaded };
    }
    @Action({ rawError: true })
    async create(data: LoyaltyBonusGeneralRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.loyaltyBonus.create(data);
        return resp;
    }
    @Action({ rawError: true })
    async update(data: LoyaltyBonusGeneralRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.loyaltyBonus.update(data);
        return resp;
    }
    /*@MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ salon: ILoyaltyBonusListItem  ; counterpartiesLoaded: boolean }> {
        let counterpartiesLoaded = false;
        const salon = await store.$repository.counterparties.fetchData(data);
        if (salon) {
            counterpartiesLoaded = true;
        }
        return { salon, counterpartiesLoaded};
    }
    @Action({rawError: true})
    async create(data: LoyaltyBonusGeneralRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.counterparties.create(data);
        return resp;
    }
    @Action({rawError: true})
    async update(data: LoyaltyBonusGeneralRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.counterparties.update(data);
        return resp;
    }
    @Action({rawError: true})
    async delete(data: {id: number}): Promise<ResponseDataType> {
        const resp = await store.$repository.counterparties.delete(data);
        return resp;
    }*/
}

export const LoyaltyBonusStore = getModule(LoyaltyBonusModule);
